import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import {
  AdjustmentAmountOption,
  Condition,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface AdjustmentAmountState {
  adjustmentAmountOption: AdjustmentAmountOption;
  adjustmentAmount: string;
}

export const ADJUSTMENT_AMOUNT = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<AdjustmentAmountState>
  >,
): ConditionType<AdjustmentAmountState, Condition.AdjustmentAmount> => ({
  name: "Total adjustment amount",
  description(state) {
    return `Adjustment amount ${state.adjustmentAmountOption.toLowerCase()} ${moneyFormat(
      { amount: +state.adjustmentAmount, currency: DEFAULT_CURRENCY },
    )}`;
  },
  Details(props: ConditionTypeDetailsProps<AdjustmentAmountState>) {
    return React.createElement(Details, props);
  },
  empty: {
    adjustmentAmountOption: AdjustmentAmountOption.EQUALS,
    adjustmentAmount: (0).toFixed(2),
  },
  fromModel(model) {
    return {
      adjustmentAmountOption: model.adjustmentAmountOption,
      adjustmentAmount: model.adjustmentAmount.toFixed(2),
    };
  },
  toModel(state) {
    return {
      type: Condition.ADJUSTMENT_AMOUNT,
      adjustmentAmountOption: state.adjustmentAmountOption,
      adjustmentAmount: +state.adjustmentAmount,
    };
  },
  valid(state) {
    return true;
  },
});
